module.exports = __webpack_public_path__ + "static/media/flyDron.9f3fcd96.gif";